const t = {
  name: "Twitter2Small",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.7124 10.5892L20.4133 2.79999H18.8254L13.0071 9.56334L8.35995 2.79999H3L10.0273 13.0273L3 21.1955H4.58805L10.7325 14.0533L15.6402 21.1955H21.0001L13.7122 10.5892H13.7127H13.7124ZM11.5374 13.1173L10.8253 12.0989L5.16015 3.99534H7.59915L12.1711 10.5352L12.8832 11.5535L18.8262 20.0543H16.3872L11.5375 13.1176V13.1171L11.5374 13.1173Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Twitter2Small
};
